import API_MAP from "../../util/API_MAP";
import API_MANAGER from "../../util/API_MANAGER";
import router from '../../router';

const state = {
	hasData: false, // 是否请求了活动数据
	activityObj: {}, // 活动对象
	sortedDate: [], // 排序过的日期数组
	selectList: [], // 已选活动数组
	shadowSelectList: [], // 已选活动影子数组
	dateWeekMap: {} // 日期星期映射
};

const getters = {
	not_finish_activity: state => {
		return state.selectList.length < 1;
	}
};

const actions = {
	// 提交基本信息
	getActivity({commit, rootState}) {
		let api = API_MAP.ACTIVITY_ALL;
		let method = 'get';
		let payload = {};
		payload.user_id = rootState.main.currentUser['user_id'];
		let successCb = (list) => {
			commit('setHasData', true);
			const currentUser = rootState.main.currentUser;
			commit('setActivityList', {list, currentUser});
		};
		let errorCb = () => {

		};
		API_MANAGER({api, method, payload, successCb, errorCb, commit})
	},
	// 更新已选活动
	updateSelect({commit, state}, cb) {
		let api = API_MAP.ACTIVITY_USER_RELATE;
		let method = 'json';
		let payload = {
			activity: state.shadowSelectList
		};
		let successCb = () => {
			commit('setSelectList', {
				list: [].concat(state.shadowSelectList),
				cb
			});
		};
		let errorCb = () => {

		};
		API_MANAGER({api, method, payload, successCb, errorCb, commit})
	}
};

const mutations = {
	// 更新请求状态
	setHasData(state, status) {
		state.hasData = status;
	},
	// 设置活动列表数据
	setActivityList(state, {list, currentUser}) {
		let currentActivityObj = {};
		let sortedDate = [];
		let selectList = [];
		let dateWeekMap = {};
		const chargeType = currentUser['charge_type'];
		list.map(item => {
			const date = item.date;
			// 判断是否有权限
			item.access = item['open_group'].indexOf(String(chargeType)) !== -1;
			// 判断上下午
			item.am = item['start_time'].split(':')[0] < 12;
			// 判断是否选择
			if (item.selected === 1 || currentUser.inviter.split(',').indexOf(item.id.toString()) !== -1) {
				selectList.push(item.id);
			}
			// 插入
			if (currentActivityObj[date]) {
				currentActivityObj[date].push(item);
			} else {
				sortedDate.push(date);
				dateWeekMap[date] = item['day_of_week'];
				currentActivityObj[date] = [item];
			}
		});
		sortedDate = sortedDate.sort();
		state.activityObj = Object.assign({}, currentActivityObj);
		state.sortedDate = sortedDate;
		state.selectList = selectList;
		state.shadowSelectList = [].concat(selectList);
		state.dateWeekMap = dateWeekMap;
	},
	// 活动勾选事件
	activitySelect(state, {type, id}) {
		let currentSelectList = JSON.parse(JSON.stringify(state.shadowSelectList));
		let index = currentSelectList.indexOf(id);
		// 当前不包含才允许新加
		if (type === 'add' && index === -1) {
			state.shadowSelectList.push(id);
		}
		// 当前包含才允许移除
		if (type === 'remove' && index !== -1) {
			state.shadowSelectList.splice(index, 1);
		}
	},
	// 设置勾选列表
	setSelectList(state, option) {
		state.selectList = option.list;
		option.cb();
	},
	// 重置已选活动影子数组
	resetShadowSelectList(state) {
		state.shadowSelectList = [].concat(state.selectList);
	}
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};
